module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [_c('div', {
    staticClass: "do-table__filters"
  }, [_c('div', {
    staticClass: "do-table__filters__left"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": "Grupper",
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTags
    },
    on: {
      "select": _vm.toggleTag,
      "clear": function($event) {
        _vm.selectedTags = []
      }
    }
  }), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": "Organisationer",
      "tags": _vm.organisations,
      "selectedTags": _vm.selectedOrganisations
    },
    on: {
      "select": _vm.selectedOrganisation,
      "clear": function($event) {
        _vm.selectedOrganisations = []
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "do-table__filters__add"
  }, [_c('span', [_vm._v("Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.users.length) + " brugere")])])]), _vm._v(" "), _c('SalarySettingsUsersTable', {
    attrs: {
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
      "filteredUsers": _vm.filteredUsers,
      "isImportOfEmployments": true
    },
    on: {
      "editEmployment": function($event) {
        return _vm.$emit('editEmployment', $event)
      },
      "setTheEditUser": function($event) {
        return _vm.$emit('setTheEditUser', $event)
      }
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bbe5ff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsUsersOpus.vue
// module id = 1539
// module chunks = 1